<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1 v-if="pestanaId == 0">Consulta De Dictámenes</h1>
        <h1 v-if="pestanaId == 1">Agendar Cita</h1>
        <h1 v-if="pestanaId == 2">Seleccionar Horario</h1>
      </div>
      <div style="display: flex">        
        <div class="col-12 padding-div-low">
          <div class="area" style="background-color:#bebebc" v-if="pestanaId == 0">
            <div class="row">
              <div class="col-3 font-black" >
                <h5>Estatus:</h5>
              </div>
              <div class="col-3 font-black">
                <h5>Juzgado:</h5>
              </div>

              <div class="col-3 font-black">
                <h5>No. de Expediente:</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <C004EstatusDeDictamen v-on:valorParaElPadre="cambioEstatusDeDictamen"
                                       :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                       :tipo="enumeraciones.tiposDeSelect.Todos"
                                       :idDelInput="'catalogoEstatusDeDictamen'"
                                       :parametros="parametros_EstatusDeDictamen"
                                       :valorDefinido="parametros_EstatusDeDictamen.ValorDefinido">
                </C004EstatusDeDictamen>
              </div>
              <div class="col-3">
                <C009Areas v-on:valorParaElPadre="cambioArea"
                           :prefijo="enumeraciones.etiquetasDeHTML.Select"
                           :tipo="enumeraciones.tiposDeSelect.Seleccione"
                           :idDelInput="'catalogoArea'"
                           :parametros="parametros_Area"
                           :valorDefinido="parametros_Area.ValorDefinido">
                </C009Areas>
              </div>

              <div class="col-3">
                <input type="text" v-model="numExpediente" class="form-control campos" placeholder="####/####" />
              </div>
              <div class="col-3">
                <input type="button" class="form-control" style="background-color:var(--verde-pj-100); color: var(--blanco-pj)" value="Buscar" @click="buscarMisDictamenes" />
              </div>
            </div>
            <div class="row new-row">
              <table class="table table-striped table-light table-hover"
                     id="tablaDictamenes">
                <thead style="background-color:#004746">
                  <tr>
                    <th>No. Folio
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(0,true)' title="Ordenar por No. Folio" /></div>
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(0,false)' title="Ordenar por No. Folio" /></div>  
                    </th>
                    <th>No. Expediente
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(1,true)' title="Ordenar por No. Folio" /></div>
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(1,false)' title="Ordenar por No. Folio" /></div>
                    </th>
                    <th>Juzgado
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(2,true)' title="Ordenar por No. Folio" /></div>
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(2,false)' title="Ordenar por No. Folio" /></div>
                    </th>
                    <th>Citas Completadas/Agendadas/Requeridas</th>
                    <th>Fecha Límite de Entrega
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(4,true)' title="Ordenar por No. Folio" /></div>
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(4,false)' title="Ordenar por No. Folio" /></div>
                    </th>
                    <th>Estatus
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(5,true)' title="Ordenar por No. Folio" /></div>
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(5,false)' title="Ordenar por No. Folio" /></div>
                    </th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-for="dictamen in dictamenes" v-bind:key="dictamen.DictamenId">
                    <td>{{dictamen.DictamenId}}</td>
                    <td>{{dictamen.Expediente.Consecutivo}}</td>
                    <td v-if="dictamen.Expediente.AreaDBPJ != null">{{dictamen.Expediente.AreaDBPJ.Nombre}}</td>
                    <td v-else>N/D</td>
                    <td>{{dictamen.CitasCompletadasAdultos}} <br /> {{dictamen.CitasCompletadasMenores}}</td>
                    <td>{{dictamen.FechaLimiteContestacionString}}</td>
                    <td>{{dictamen.EstatusDeDictamen.Nombre}}</td>
                    <td class="d-flex justify-content-around">
                      <i class="fas fa-calendar fa-lg" @click="cambiarPestana(2,dictamen.DictamenId)" v-if="dictamen.EstatusDeDictamen.Nombre != 'Terminado' && dictamen.EstatusDeDictamen.Nombre != 'Cancelado'" title="Agendar Cita" />
                      <i class="fas fa-check fa-lg" @click="mostrarModalFinalizarDictamen(dictamen.DictamenId)" v-if="dictamen.EstatusDeDictamen.Nombre != 'Terminado' && dictamen.EstatusDeDictamen.Nombre != 'Cancelado'" title="Concluir Dictamen" />
                      <i class="fas fa-file fa-lg" @click="mostrarModalGenerarDocumento(dictamen.DictamenId)" v-if="dictamen.EstatusDeDictamen.Nombre != 'Asignado'" title="Generar Documento" />
                      <i class="fas fa-folder-open fa-lg" @click="verAnexos(dictamen.DictamenId, dictamen.RutaOficio, dictamen.DictamenRuta)" v-if="dictamen.EstatusDeDictamen.Nombre != 'Asignado'" title="Consultar Documentos Anexos" />
                      <i class="fas fa-archive fa-lg" @click="mostrarModalExpedienteElectronico(dictamen.Expediente.ExpedienteId, dictamen.Expediente.Consecutivo)" v-if="dictamen.Expediente.MateriaId_002DBPJ == 4" title="Consultar Expediente Electrónico" />
                      <i class="fas fa-info-circle fa-lg" @click="irDetalleDeDictamen(dictamen.DictamenId)" title="Ver Detalle de Dictamen" />
                    </td>
                  </tr>
                  <tr v-if="dictamenes.length == 0"><td colspan="7">No se encontraron dictámenes en la búsqueda.</td></tr>
                </tbody>
              </table>
            </div>
            <div class="modal fade"
                 id="modalFinalizarDictamen"
                 tabindex="-1"
                 role="dialog"
                 aria-labelledby="exampleModalLabel"
                 aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Finalizar Dictámen</h5>
                    <button type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <br />
                    <div class="row">
                      <div class="col-8">
                        <h5>Estatus Final:</h5>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <select class="form-control" v-model="estatusFinalDictamen">
                          <option value="-1">Seleccione un estatus</option>
                          <option value="4">Terminado</option>
                          <option value="5">Cancelado</option>
                        </select>
                      </div>
                    </div>
                    <div class="row new-row">
                      <div class="col-12">
                        <h5>Dictámen:</h5>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <input type="file" class="form-control" id="subirDictamen" @change="guardarEvento" accept=".doc, .docx" />
                      </div>
                    </div>
                    <div class="row new-row">
                      <div class="col-12">
                        <h5>Fecha de Entrega al Juzgado:</h5>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <input type="date" v-model="fechaEntrega" class="form-control" />
                      </div>
                    </div>


                  </div>
                  <div class="modal-footer">
                    <button type="button"
                            class="btn btn-primary"
                            data-dismiss="modal"
                            @click="finalizarDictamen" :disabled="deshabilitarBotonFinalizar">
                      Aceptar
                    </button>
                    <button type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal">
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal fade"
                 id="modalGenerarDocumento"
                 tabindex="-1"
                 role="dialog"
                 aria-labelledby="exampleModalLabel"
                 aria-hidden="true">
              <div class="modal-dialog" role="document" style="max-width: 60vw">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Generar Documento</h5>
                    <button type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <br />
                    <div class="row">
                      <div class="col-8">
                        <h5>Tipo de Documento:</h5>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <C010TiposPlantillas v-on:valorParaElPadre="cambioTipoPlantilla"
                                             :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                             :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                             :idDelInput="'catalogoTipoPlantilla'"
                                             :parametros="parametros_TipoPlantilla"
                                             :valorDefinido="parametros_TipoPlantilla.ValorDefinido">
                        </C010TiposPlantillas>
                      </div>
                    </div>
                    <div class="row new-row" v-show="parametros_TipoPlantilla.TipoPlantillaId == 3">
                      <div class="col-12">
                        <table class="table table-striped table-light table-hover"
                               id="tablaCitas">
                          <thead class="thead-dark">
                            <tr>
                              <th>Seleccionar</th>
                              <th>No. Folio</th>
                              <th>Nombre del Evaluado</th>
                              <th>Fecha Programada</th>
                              <th>Fecha Original</th>
                            </tr>
                          </thead>
                          <tbody class="text-dark">
                            <tr v-for="cita in citas" v-bind:key="cita.CitaDeDictamenId">
                              <td><input type="checkbox" class="form-control" v-model="cita.Seleccionada" /></td>
                              <td>{{cita.CitaDeDictamenId}}</td>
                              <td>{{cita.PersonaEvaluada.Nombre}} {{cita.PersonaEvaluada.ApellidoPaterno}} {{cita.PersonaEvaluada.ApellidoMaterno}}</td>
                              <td>{{cita.FechaCitaString}}</td>
                              <td>{{cita.CitaDeDictamenDeReferencia.FechaCitaString}}</td>
                              </tr>
                            <tr v-if="citas.length == 0"><td colspan="6">No se encontraron citas en la búsqueda.</td></tr>                            
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button"
                            class="btn btn-primary"
                            data-dismiss="modal"
                            @click="generarDocumento" :disabled="parametros_TipoPlantilla.TipoPlantillaId == -1">
                      Aceptar
                    </button>
                    <button type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal">
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal fade"
                 id="modalExpedienteElectronico"
                 tabindex="-1"
                 role="dialog"
                 aria-labelledby="exampleModalLabel"
                 aria-hidden="true">
              <div class="modal-dialog" role="document" style="max-width: 60vw">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Generar Documento</h5>
                    <button type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <br />
                    <div class="row">
                      <div class="col-1">
                        <b>Año de Consulta:</b>
                      </div>

                      <div class="col-3">
                        <input type="number" v-model="parametros_VerExpedienteElectronico.AnoBusquedaString" class="form-control" />
                      </div>
                      <div class="col-6"></div>
                      <div class="col-2">
                        <input type="button" class="form-control" style="background-color:#004746" @click="getDatosParaExpedienteElectronico" value="Buscar" />
                      </div>

                    </div>
                    <div class="row new-row" v-show="mostrarExpedienteElectronico">
                      <div class="col-12">
                        <VerExpedienteElectronico :parametros="parametros_VerExpedienteElectronico" :key="parametros_VerExpedienteElectronico.key"></VerExpedienteElectronico>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="areaLocalGris" v-else-if="pestanaId == 1">
            <div class="row">
              <div class="col-3">
                <h5>Fecha: *</h5>
              </div>
              <div class="col-3">
                <h5>Hora: *</h5>
              </div>

              <div class="col-3">
                <h5>Duración (minutos): *</h5>
              </div>
              <div class="col-3">
                <h5>Sala Lúdica: </h5>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <input type="date" class="form-control" v-model="fechaCita" />
              </div>
              <div class="col-3">
                <input type="time" class="form-control" v-model="horaCita" />
              </div>
              <div class="col-3">
                <input type="number" class="form-control" v-model="duracion" min="0" />
              </div>
              <!--<div class="col-2">
                <input type="checkbox" v-model="usaSala" :disabled="!habilitarSala" style="margin-right:5px;" />

                <span>Se utilizará la sala lúdica</span>
              </div>-->
              <div class="col-3">
                <C013SalasLudicas v-on:valorParaElPadre="cambioSalaLudica"
                                  :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                  :tipo="enumeraciones.tiposDeSelect.Ninguna"
                                  :idDelInput="'catalogoSalaLudica'"
                                  :parametros="parametros_SalaLudica"
                                  :valorDefinido="parametros_SalaLudica.ValorDefinido"
                                  :key="parametros_SalaLudica.key"
                                  >
                </C013SalasLudicas>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-3">
                <h5>Personas relacionadas al expediente</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <table class="table table-striped table-light table-hover"
                       id="tablaPersonas">
                  <thead style="background-color:var(--verde-pj-100); color: var(--blanco-pj)">
                    <tr>
                      <th>Nombre</th>
                      <th>Menor de Edad</th>
                      <th>Sexo</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="(persona,indice) in personasExpediente" v-bind:key="indice">
                      <td>{{persona.Nombre}} {{persona.ApellidoPaterno}} {{persona.ApellidoMaterno}}</td>
                      <td v-if="persona.EsMenor"><i class="fa fa-check fa-lg"></i></td>
                      <td v-else><i class="fa fa-times fa-lg"></i></td>
                      <td v-if="persona.TipoSexoId_0012DBPJ != 0">{{persona.TipoSexo.Nombre}}</td>
                      <td v-else>N/D</td>
                      <td>
                        <i class="fas fa-user-plus fa-lg" @click="cargarDatosPersona(persona)" title="Seleccionar Persona" />
                      </td>
                    </tr>
                    <tr v-if="dictamenes.length == 0"><td colspan="7">No se encontraron personas en la búsqueda.</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-3">
                <h5>Nombre del Evaluado: *</h5>
              </div>
              <div class="col-3">
                <h5>Apellido Paterno:</h5>
              </div>
              <div class="col-3">
                <h5>Apellido Materno:</h5>
              </div>
              <div class="col-3">
                <h5>Sexo: *</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <input type="text" class="form-control" v-model="nombreEvaluado" />
              </div>
              <div class="col-3">
                <input type="text" class="form-control" v-model="apellidoPaternoEvaluado" />
              </div>
              <div class="col-3">
                <input type="text" class="form-control" v-model="apellidoMaternoEvaluado" />
              </div>
              <div class="col-3">
                <select class="form-control" v-model="sexoEvaluadoId">
                  <option value="0">Seleccione un sexo</option>
                  <option value="1">Masculino</option>
                  <option value="2">Femenino</option>
                </select>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-3">
                <h5>Edad del Evaluado</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <input type="number" class="form-control" v-model="edadEvaluado" min="0" />
              </div>
              <div class="col-2">
                <input type="checkbox" v-model="esMenor" style="margin-right:5px;" />

                <span>Menor de Edad</span>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-3">
                <h5>Tema a Evaluar *</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <C012TemasEvaluaciones v-on:valorParaElPadre="cambioTemaEvaluacion"
                                       :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                       :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                       :idDelInput="'catalogoTemaEvaluacion'"
                                       :parametros="parametros_TemaEvaluacion"
                                       :valorDefinido="parametros_TemaEvaluacion.ValorDefinido">
                </C012TemasEvaluaciones>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr />
              </div>
            </div>
            <div class="row new-row">
              <div class="col-6"></div>
              <div class="col-2">
                <input type="button" value="Cancelar" class="form-control" @click="cambiarPestana(0, 0);" />
              </div>
              <div class="col-2">
                <input type="button" value="Guardar y Agendar Nueva Cita" class="form-control" :disabled="validarBotonCita" @click="guardarCitaDictamen(2)" />
              </div>
              <div class="col-2">
                <input type="button" value="Guardar y Salir" class="form-control" :disabled="validarBotonCita" @click="guardarCitaDictamen(0)" />
              </div>
            </div>
            <div class="row"></div>
          </div>
          <div class="areaLocalVerde" v-else-if="pestanaId == 2">
            <div class="row new-row">
              <div class="col-12">
                <CalendarioDeCitas :parametros="parametros_CalendarioDeCitas"
                                   :key="parametros_CalendarioDeCitas.key"
                                   v-on:valorParaElPadreCalendarioDeCitas="validarBloque">
                </CalendarioDeCitas>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-10"></div>
              <div class="col-2">
                <input type="button" value="Cancelar" class="form-control" @click="cambiarPestana(0, 0);" />
              </div>
            </div>
            <div class="row"></div>
          </div>
          <div class="areaLocalGris" v-else-if="pestanaId == 3">
            <div class="row">
              <div class="col-12">
                <table class="table table-striped table-light table-hover"
                       id="tablaAnexos">
                  <thead style="background-color:#004746; color: white">
                    <tr>
                      <th>Nombre</th>
                      <th>Fecha de Creación</th>
                      <th>Fecha de Modificación</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="anexo in anexos" v-bind:key="anexo.AnexoId">
                      <td>{{anexo.Nombre}}</td>
                      <td>{{anexo.FechaCreacionString}}</td>
                      <td>{{anexo.FechaUltimaModificacionString}}</td>

                      <td class="d-flex justify-content-around">
                        <i class="fas fa-upload fa-lg" @click="mostrarModalResubirAnexo(anexo.AnexoId)" title="Subir Archivo" />
                        <i class="fas fa-download fa-lg" @click="descargarArchivo(anexo.RutaArchivo)" title="Descargar Archivo" />
                      </td>
                    </tr>
                    <tr v-if="anexos.length == 0"><td colspan="4">No se encontraron anexos en la búsqueda.</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row new-row" v-if="rutaOficio != '' || dictamenRuta != ''">
              <div class="col-2" v-if="rutaOficio != ''">
                <input type="button" class="form-control" value="Descargar Notificación" @click="descargarArchivo(rutaOficio)" />
              </div>
              <div class="col-2" v-if="dictamenRuta != ''">
                <input type="button" class="form-control" value="Descargar Dictamen" @click="descargarArchivo(dictamenRuta)" />
              </div>

            </div>
            <div class="row new-row">
              <div class="col-10"></div>
              <div class="col-2">
                <input type="button" value="Volver" class="form-control" @click="cambiarPestana(0,0)" />
              </div>
            </div>
            <div class="row"></div>
            <div class="modal fade"
                 id="modalResubirAnexo"
                 tabindex="-1"
                 role="dialog"
                 aria-labelledby="exampleModalLabel"
                 aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Resubir Documento Anexo</h5>
                    <button type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <br />
                    <div class="row new-row">
                      <div class="col-12">
                        <h5>Documento Anexo:</h5>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <input type="file" class="form-control" id="subirAnexo" @change="guardarEventoAnexo" accept=".doc, .docx" />
                      </div>
                    </div>


                  </div>
                  <div class="modal-footer">
                    <button type="button"
                            class="btn btn-primary"
                            data-dismiss="modal"
                            @click="resubirAnexo" :disabled="deshabilitarBotonResubirAnexo">
                      Aceptar
                    </button>
                    <button type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal">
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  import CalendarioDeCitas from '@/components/SIPSIC/Dictamenes/ControlDeDictamenes/CalendarioDeCitas.vue'
  import VerExpedienteElectronico from '@/components/SIPSIC/Dictamenes/ConsultaDeDictamenes/VerExpedienteElectronico.vue'
  export default {
    data() {
      return {
        enumeraciones,
        catalogos,
        dictamenes: [],
        citas: [],
        NumeroFilasPagina: 10,
        parametros_EstatusDeDictamen: {
          ValorDefinido: 2,
          EstatusDictamenId: 2,
          ConInactivos: false
        },
        parametros_Area: {
          ValorDefinido: -1,
          AreaId: null,
          AreaId_DBPJ: null,
        },
        parametros_TipoPlantilla: {
          ValorDefinido: -1,
          TipoPlantillaId: null
        },
        parametros_TemaEvaluacion: {
          ValorDefinido: -1,
          TemaEvaluacionId: null
        },
        parametros_SalaLudica: {
          ValorDefinido: -2,
          SalaLudicaId: -2,
          key: 0,
          fechaCita: null
        },
        parametros_CalendarioDeCitas: { FiltrarPorPsicologo: true, fechaInicial: null, key: 0 },
        parametros_VerExpedienteElectronico: {
          AreaId_Equitas: null,
          Consecutivo: null,
          Ano: null,
          TipoDocumentoId_Equitas: null,
          Numero: null,
          AnoBusqueda: 0,
          AnoBusquedaString: "2021",
          key: 0
        },
        numExpediente: "",
        dictamenId: null,
        pestanaId: 0,
        //Variables Agendar Cita
        fechaCita: null,
        horaCita: null,
        duracion: 0,
        usaSala: false,
        apellidoPaternoEvaluado: "",
        apellidoMaternoEvaluado: "",
        nombreEvaluado: "",
        sexoEvaluadoId: 0,
        edadEvaluado: 0,
        esMenor: false,
        temaEvaluarCita: "",
        estatusFinalDictamen: -1,
        habilitarSala: true,
        eventoDocumento: null,
        eventoDocumentoAnexo: null,
        personasExpediente: [],
        anoConsultaExpedienteElectronico: 2021,
        expedienteId: 0,
        mostrarExpedienteElectronico: false,
        anexos: [],
        anexoId: 0,
        rutaOficio: "",
        dictamenRuta: "",
        fechaEntrega: ""
      }
    },
    components: {
      C004EstatusDeDictamen: catalogos.SIPSIC.C004EstatusDeDictamen,
      C009Areas: catalogos.SIPSIC.C009Areas,
      C010TiposPlantillas: catalogos.SIPSIC.C010TiposPlantillas,
      C012TemasEvaluaciones: catalogos.SIPSIC.C012TemasEvaluaciones,
      C013SalasLudicas: catalogos.SIPSIC.C013SalasLudicas,
      CalendarioDeCitas,
      VerExpedienteElectronico,
    },
    methods: {
      buscarMisDictamenes: function () {
        var peticion = {
          "esPrueba": false,
          "EstatusId": this.parametros_EstatusDeDictamen.EstatusDictamenId,
          "PsicologoId": 0,
          "JuzgadoId": this.parametros_Area.AreaId_DBPJ,
          "NumExpediente": this.numExpediente
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.GetMisDictamenes, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.dictamenes = response.data.Dictamenes

            this.$nextTick(() => {
              PaginarTabla('tablaDictamenes', this.NumeroFilasPagina)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      buscarCitasDictamen: function () {
        var peticion = {
          "esPrueba": false,
          "EstatusCitaDeDictamenId": 1,
          "TextoBusquedaLibre": "",
          "FechaInicial": null,
          "FechaFinal": null,
          "DictamenId": this.dictamenId,
          "SoloReagendadas": true
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.GetMisCitas, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.citas = response.data.CitasDeDictamen

            this.$nextTick(() => {
              PaginarTabla('tablaCitas', 5)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      buscarPersonasExpediente: function () {
        var peticion = {
          "esPrueba": false,
          "DictamenId": this.dictamenId
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.GetPersonasExpediente, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.personasExpediente = response.data.PersonasExpediente

            this.$nextTick(() => {
              PaginarTabla('tablaPersonas', 5)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      guardarCitaDictamen: function (pestana) {
        const salaLudicaId = (this.parametros_SalaLudica.SalaLudicaId > 0) ? this.parametros_SalaLudica.SalaLudicaId : null;
        var peticion = {
          "FechaCita": this.fechaCita,
          "HoraCita": this.horaCita,
          "DuracionCita": this.duracion,
          "UsaSala": false,
          "SalaLudicaId": salaLudicaId,
          "NombreEvaluado": this.nombreEvaluado,
          "ApellidoPaternoEvaluado": this.apellidoPaternoEvaluado,
          "ApellidoMaternoEvaluado": this.apellidoMaternoEvaluado,
          "SexoId": parseInt(this.sexoEvaluadoId),
          "EdadEvaluado": this.edadEvaluado,
          "EsMenor": this.esMenor,
          "TemaEvaluacionId": this.parametros_TemaEvaluacion.TemaEvaluacionId,
          "DictamenId": this.dictamenId
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.GuardarCitaDictamen, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            var dictamenIdAux = (pestana == 0) ? 0 : this.dictamenId
            this.parametros_CalendarioDeCitas.fechaInicial = this.fechaCita;
            this.cambiarPestana(pestana, dictamenIdAux);
            this.buscarMisDictamenes();
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      generarDocumento: function () {
        var citasId = []
        if (this.parametros_TipoPlantilla.TipoPlantillaId == 3)
          this.citas.forEach(function (cita) {
            if (cita.Seleccionada) {
              citasId.push(cita.CitaDeDictamenId);
            }
          });
        var peticion = {
          "DictamenId": this.dictamenId,
          "TipoPlantillaId": this.parametros_TipoPlantilla.TipoPlantillaId,
          "CitasId": citasId,
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.GenerarDocumentoAnexo, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.descargarArchivo(response.data.RutaArchivo);
            //this.linkDescarga = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=//fsapp/Psicologia/2021/Juzgado Primero de lo Familiar/Dictamenes/Anexos/16/Reagendamiento_202162810937.doc`
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      descargarArchivo: function (rutaArchivo) {
        if (rutaArchivo != undefined) {
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaArchivo}`
          //console.log(a.href);
          a.click();
        }
      },
      getDatosParaExpedienteElectronico: function () {
        var peticion = {
          "esPrueba": false,
          "ExpedienteId": this.expedienteId
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.GetDatosParaExpedienteElectronico, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            if (response.data.Satisfactorio == "1") {
              this.parametros_VerExpedienteElectronico.AreaId_Equitas = response.data.AreaId_Equitas;
              this.parametros_VerExpedienteElectronico.Consecutivo = response.data.Consecutivo;
              this.parametros_VerExpedienteElectronico.Ano = response.data.Ano
              this.parametros_VerExpedienteElectronico.TipoDocumentoId_Equitas = response.data.TipoDocumentoId_Equitas
              this.parametros_VerExpedienteElectronico.Numero = response.data.Numero
              this.parametros_VerExpedienteElectronico.AnoBusqueda = parseInt(this.parametros_VerExpedienteElectronico.AnoBusquedaString)
              //this.parametros_VerExpedienteElectronico.key = 0
              var nuevaKey = (this.parametros_VerExpedienteElectronico.key == this.expedienteId) ? 0 : this.expedienteId;
              this.$nextTick(() => {
                this.parametros_VerExpedienteElectronico.key = nuevaKey
              })
              this.mostrarExpedienteElectronico = true;
            } else {
              comun.mensajeDeAlerta(response.data.Satisfactorio.Mensaje, null, null)
            }
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      getAnexosDictamen: function () {
        var peticion = {
          "esPrueba": false,
          "DictamenId": this.dictamenId
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.GetAnexosDictamen, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.anexos = response.data.Anexos
            this.$nextTick(() => {
              PaginarTabla('tablaAnexos', 10)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      ordenar: function (columna, sentido) {
        this.columna = columna;
        this.sentido = sentido;
        this.dictamenes.sort(this.comparar);
        this.$nextTick(() => {
              PaginarTabla('tablaDictamenes', 10)
            })
      },comparar: function (a, b) {
        var filaA = 0;
        var filaB = 0;
        if (this.columna == 0) {
          filaA = a.DictamenId;
          filaB = b.DictamenId;
        }
        else if(this.columna === 1){
          filaA = a.Expediente.Consecutivo;
          filaB = b.Expediente.Consecutivo;
        }
        else if(this.columna === 2){
          filaA = (a.Expediente.AreaDBPJ) ? a.Expediente.AreaDBPJ.Nombre : "N/D";
          filaB = (b.Expediente.AreaDBPJ) ? b.Expediente.AreaDBPJ.Nombre : "N/D";
        } 
        else if(this.columna === 4){
          const from = a.FechaLimiteContestacionString.split("/");
          filaA = new Date(from[2], from[1] - 1, from[0]);
          const to = b.FechaLimiteContestacionString.split("/");
          filaB = new Date(to[2], to[1] - 1, to[0]);
        }
        else if (this.columna === 5) {
          filaA = a.EstatusDictamenId;
          filaB = b.EstatusDictamenId;
        } else {
          return 0;
        }        
        let comparison = 0;
        if (filaA > filaB) {
          comparison = 1;
        } else if (filaA < filaB) {
          comparison = -1;
        }
        if(!this.sentido)
          comparison *= -1;        
        return comparison;
      },
      mostrarModalFinalizarDictamen: function (dictamenId) {
        this.resetearValoresFinalizarDictamen();
        this.dictamenId = dictamenId
        $('#modalFinalizarDictamen').modal('toggle');
      },
      mostrarModalResubirAnexo: function (anexoId) {
        this.resetearValoresResubirAnexo();
        this.anexoId = anexoId
        $('#modalResubirAnexo').modal('toggle');
      },
      mostrarModalGenerarDocumento: function (dictamenId) {
        //this.resetearValoresFinalizarDictamen();
        this.dictamenId = dictamenId
        this.buscarCitasDictamen();
        $('#modalGenerarDocumento').modal('toggle');
      },
      mostrarModalExpedienteElectronico: function (expedienteId, consecutivo) {
        //this.resetearValoresFinalizarDictamen();
        this.parametros_VerExpedienteElectronico.AnoBusquedaString = consecutivo.substring(5, 9);
        this.expedienteId = expedienteId
        $('#modalExpedienteElectronico').modal('toggle');
        this.mostrarExpedienteElectronico = false;
      },
      verAnexos: function (dictamenId, rutaOficio, dictamenRuta) {
        this.rutaOficio = rutaOficio;
        this.dictamenRuta = dictamenRuta
        this.cambiarPestana(3, dictamenId);
        this.$nextTick(() => {
          this.getAnexosDictamen();
        })

      },
      cambiarPestana: function (pestana, dictamenId) {

        this.pestanaId = pestana
        this.dictamenId = dictamenId;
        this.$forceUpdate();
        if (pestana == 0) {
          this.$nextTick(() => {
            PaginarTabla('tablaDictamenes', this.NumeroFilasPagina)
          })
        }
        else {
          this.$nextTick(() => {
            $("#navtablaDictamenes").remove()
          });
          if (pestana == 2) { this.parametros_CalendarioDeCitas.key++;}
        }
      },
      cambioEstatusDeDictamen(datos) { //Administra los cambios en el componente de Estatus De Dictamen
        catalogos
        //console.log(datos);
        this.parametros_EstatusDeDictamen.EstatusDictamenId = parseInt(datos[0].target.value);
      },
      cambioArea(datos) { //Administra los cambios en el componente de Área
        catalogos
        //console.log(datos);
        this.parametros_Area.AreaId = parseInt(datos[0].target.value);
        this.parametros_Area.AreaId_DBPJ = parseInt(datos[0].target.options[datos[0].target.selectedIndex].getAttribute('areaId_DBPJ'));
      },
      cambioTipoPlantilla(datos) { //Administra los cambios en el componente de TipoPlantilla
        catalogos
        //console.log(datos);
        this.parametros_TipoPlantilla.TipoPlantillaId = parseInt(datos[0].target.value);
      },
      cambioTemaEvaluacion(datos) { //Administra los cambios en el componente de TipoPlantilla
        catalogos
        //console.log(datos);
        this.parametros_TemaEvaluacion.TemaEvaluacionId = parseInt(datos[0].target.value);
      },
      cambioSalaLudica(datos) { //Administra los cambios en el componente de TipoPlantilla
        catalogos
        //console.log(datos);
        this.parametros_SalaLudica.SalaLudicaId = parseInt(datos[0].target.value);
      },
      validarBloque: function (datos) {
        if (datos.title.includes("Disponible")) {
          if (datos.title.includes("Inhábil")) {
          bootbox.dialog({
                  title: 'Mensaje del sistema',
                  message: '¿Seguro que desea agendar en un día inhábil?',
                  size: 'medium',
                  buttons: {
                    aceptar: {
                      label: "Aceptar",
                      className: 'btn btn-primary',
                      callback: () => {
                        this.obtenerFechaHora(datos);
                      }
                    },
                    cancelar: {
                      label: "Cancelar",
                      className: 'btn btn-primary',
                      callback: () => {
                      }
                    }
                  }
                });
          }
          else{
            this.obtenerFechaHora(datos);
          }
        } else {
          comun.mensajeDeAlerta("Horario no válido.", null, null)
        }

      },
      obtenerFechaHora: function(datos){
        this.fechaCita = datos.start.format("YYYY-MM-DD");
        this.horaCita = datos.start.format("HH:mm:ss");
        this.usaSala = false;
        this.habilitarSala = !datos.title.includes("(Sala Lúdica)")
        this.resetearValoresAgendarCita();
        this.buscarPersonasExpediente();
        this.pestanaId = 1;
        this.parametros_SalaLudica.fechaCita = this.fechaCita + " " + this.horaCita
        this.parametros_SalaLudica.key++;
      },
      guardarEvento: function (event) {
        //comun.SeEstaCargandoInformacion(true);
        //console.log(event)

        this.eventoDocumento = event;
        //console.log(this.eventoDocumento)
      },
      guardarEventoAnexo: function (event) {
        this.eventoDocumentoAnexo = event;
      },
      cargarDatosPersona: function (persona) {
        this.nombreEvaluado = persona.Nombre
        this.apellidoPaternoEvaluado = persona.ApellidoPaterno
        this.apellidoMaternoEvaluado = persona.ApellidoMaterno
        if (persona.TipoSexoId_0012DBPJ != 0) {
          this.sexoEvaluadoId = (persona.TipoSexoId_0012DBPJ != 0) ? persona.TipoSexoId_0012DBPJ : -1
        }
        this.edadEvaluado = (persona.Edad != null) ? persona.Edad : 0;
        this.esMenor = persona.EsMenor;
      },
      finalizarDictamen() {
        comun.SeEstaCargandoInformacion(true);

        // Se carga la imagen al formulario.
        var datosDelFormulario = new FormData();
        datosDelFormulario.set("EstatusId", this.estatusFinalDictamen);
        datosDelFormulario.set("DictamenId", this.dictamenId);
        datosDelFormulario.set("FechaEntrega", this.fechaEntrega);
        datosDelFormulario.append("document", this.eventoDocumento.target.files[0]);

        axios
          .post(
            api.conexion + api.SIPSIC.funciones.FinalizarDictamen,
            datosDelFormulario,
            comun.CrearElHeaderDeAutorizacion(
              this.$store.state.Login_AutorizacionOriginal,
              true
            )
          )
          .then(respuesta => {
            //console.log(respuesta);
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.buscarMisDictamenes();
            }
            comun.SeEstaCargandoInformacion(false);
          })
          .catch(excepcion => {
            comun.mensajeDeAlerta(
              comun.mensajeDeError(enumeraciones.error.E500),
              null,
              null
            );
            comun.SeEstaCargandoInformacion(false);
          });
      },
      resubirAnexo() {
        comun.SeEstaCargandoInformacion(true);

        // Se carga la imagen al formulario.
        var datosDelFormulario = new FormData();
        datosDelFormulario.set("AnexoId", this.anexoId);
        datosDelFormulario.append("document", this.eventoDocumentoAnexo.target.files[0]);

        axios
          .post(
            api.conexion + api.SIPSIC.funciones.ResubirAnexoDeDictamen,
            datosDelFormulario,
            comun.CrearElHeaderDeAutorizacion(
              this.$store.state.Login_AutorizacionOriginal,
              true
            )
          )
          .then(respuesta => {
            //console.log(respuesta);
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.$nextTick(() => {
                this.getAnexosDictamen();
              })
              //this.ImagenFirmaAutografaBase64 = respuesta.data.ImagenFirmaAutografaBase64;
            }
            comun.SeEstaCargandoInformacion(false);
          })
          .catch(excepcion => {
            comun.mensajeDeAlerta(
              comun.mensajeDeError(enumeraciones.error.E500),
              null,
              null
            );
            comun.SeEstaCargandoInformacion(false);
          });
      },
      irDetalleDeDictamen: function (dictamenId) {
        //Redirigeal usuario a la pantalla de editarusuario mandando como parametro el id de persona a editar
        this.$router.push({
          name: "DetalleDeDictamen",
          params: { dictamenId: dictamenId }
        });
      },
      resetearValoresFinalizarDictamen: function () {
        this.estatusFinalDictamen = -1;
        this.event = null;
        document.getElementById("subirDictamen").value = "";
        this.fechaEntrega = "";
      }, resetearValoresResubirAnexo: function () {
        this.eventoAnexo = null;
        document.getElementById("subirAnexo").value = "";
      }, resetearValoresAgendarCita: function () {
        this.duracion = 0;
        this.nombreEvaluado = "";
        this.apellidoPaternoEvaluado = "";
        this.apellidoMaternoEvaluado = "";
        this.sexoEvaluadoId = -1;
        this.edadEvaluado = 0;
        this.esMenor = false;
        this.temaEvaluarCita = "";
      }

    }, mounted: function mounted() {
      this.buscarMisDictamenes();

    },
    computed: {
      validarBotonCita: function () {
        return this.fechaCita == null || this.fechaCita == "" || this.horaCita == null || this.horaCita == "" || this.duracion == 0 || this.nombreEvaluado == "" || this.nombreEvaluado == null || this.sexoEvaluadoId == 0 || this.parametros_TemaEvaluacion.TemaEvaluacionId == null || this.parametros_TemaEvaluacion.TemaEvaluacionId == -1;
      }, deshabilitarBotonFinalizar: function () {
        return this.estatusFinalDictamen == -1 || this.eventoDocumento == null || this.eventoDocumento.target.files.length == 0 || this.fechaEntrega == ""
      }, deshabilitarBotonResubirAnexo: function () {
        return this.eventoDocumentoAnexo == null || this.eventoDocumentoAnexo.target.files.length == 0
      }
    }
  }
</script>

<style scoped>


  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }

  .padding-div-low {
    padding-top: 40px;
  }

  .alinear_izq {
    float: left;
  }

  .alinear_der {
    float: right;
  }

  .contenedor-puntero {
    background: #212529;
    border-radius: 2px;
    padding: 10px;
    border: 1px solid white;
    margin-bottom: 1.5em;
  }
</style>
<style>
  .padding-div-low {
    padding-top: 40px;
  }

  #calendario_agendar_siccij .fc-view-container {
    background-color: transparent !important;
    color: #343a40 !important;
    border-color: #212529 !important;
  }

  #calendario_agendar_siccij .fc-view table {
    border-color: #212529 !important;
  }

  #calendario_agendar_siccij .fc-axis {
    background-color: #504f54;
    color: white !important;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
  }

  #calendario_agendar_siccij .fc-day-header {
    background-color: #212529 !important;
    color: white !important;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
    padding: .75rem !important;
  }

  #calendario_agendar_siccij .fc-button {
    background-color: whitesmoke !important;
    border: none !important;
    padding: .375rem 1.35rem !important;
    color: #212529 !important;
    text-shadow: none !important;
    display: inline-block !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    font-size: 1rem !important;
    border-radius: .25rem !important;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out !important;
  }

  #calendario_agendar_siccij .fc-state-active {
    background-color: rgb(174, 174, 174) !important;
  }

  #calendario_agendar_siccij .fc-button:focus {
    outline: none !important;
  }

  #calendario_agendar_siccij .fc-today {
    background-color: rgba(242,242,242,0.5) !important;
    color: white !important;
  }

  #calendario_agendar_siccij .fc-day-number {
    color: white !important;
  }

  #calendario_agendar_siccij .fc-event {
    background-color: #212529;
    border-color: #32383e !important;
    color: white !important;
    padding: 0 .375rem !important;
    font-size: 1.0em;
    border-radius: .25rem !important;
    width: 80% !important;
    text-align: center !important;
    margin: auto !important;
  }

  tr {
  }
  .campos{
  background-color: white;
  color: black;
  }
  .font-black{
    color: black;
  }
  .areaLocalVerde{
  background-color: var(--verde-pj-100);
  box-shadow: 0px 6px 20px 4px #161616;
  padding: 25px;
}
.areaLocalGris{
  background-color: #bebebc;
  color: black;
  box-shadow: 0px 6px 20px 4px #161616;
  padding: 25px;
}
</style>




// WEBPACK FOOTER //
// src/components/SIPSIC/Dictamenes/ConsultaDeDictamenes/ConsultaDeDictamenes.vue